
export class ParticipanteReuniao {
    id: number;
    nome: string;
    origem: string;
    idReuniao: number;
}
